import axios from '@/libs/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libs/react-query';
import { Response } from '@/types/response';
import { useQuery } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant';
import { User } from '../types';
import { strToUnix } from '@/utils/format'; //

//
export interface SelectRequest {
  id?: number;
  mobile?: string;
  real_name?: string;
  id_card?: string;
  name?: string;
  login_ip?: string;
  register_ip?: string;
  pid?: number;
  has_lt_code?: number;
  final_id?: number;
  is_proxy?: number;
  is_active?: number;
  status?: number;
  is_captain?: number;
  group_type?: number;
  created_at?: [number, number];
  recommend_mobile?: string;
  total_deposit?: string;
  total_withdraw?: string;
  card_num?: string;
  recommend_id?: string;
  auth_status?: number;
  //
  date?: string;
  dates?: string[];
  pageIndex?: number;
  pageSize?: number;
}

export interface SelectResponse extends Response {
  data: {
    total: number;
    items: User[];
  };
}

//
export const selection = (data: SelectRequest): Promise<SelectResponse> => {
  return axios.post(Urls.selectUrl, {
    page: data.pageIndex,
    page_size: data.pageSize,
    filters: {
      ...data,
      date: data.date ? strToUnix(`${data.date} 00:00:00`) : undefined,
      dates:
        Array.isArray(data.dates) && data.dates.length === 2
          ? [strToUnix(`${data.dates[0]} 00:00:00`), strToUnix(`${data.dates[1]} 23:59:59`)]
          : undefined,
    },
    orders: {
      created_at: {
        desc: true,
        enable: true,
      },
    },
  });
};

type QueryFnType = typeof selection;

interface useSelectOptions {
  params: SelectRequest;
  config?: QueryConfig<QueryFnType>;
}

//
export const useSelect = ({ params, config }: useSelectOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>(
    [ListQueryKey, params],
    () => selection(params),
    config
  );
};
